module.exports = __webpack_public_path__ + "static/img/test_tab2.eeca41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/test/test_tab2.png
// module id = Yfzv
// module chunks = 1